export const WeiToEth = (value: string | number) => {
    return BigInt(value) / BigInt(Math.pow(10, 18))
}

export const EthToWei = (value: string | number) => {
    return BigInt(value) * BigInt(Math.pow(10, 18))
}